export const Recipes = [
  {
    id: "chickenAndPotatoes",
    shortname: "Herb & Garlic Sheet Pan Chicken",
    name: "Sheet Pan Herb & Garlic Chicken with Green Bean and Potato Salad",
    description:
      "Cleanup is a cinch with this chicken and potato dinner roasted all on one pan. An Italian herb and garlic dressing flavors not only the roasted chicken and veg, but also the arugula salad that goes along with it.",
    image: "sheetPanHerbChickenGreenBean.jpg",
    category: "dressings",
    products: ["italianHerb"], //list of specific products this recipe pairs with
    featured: true, //show on homepage
    ingredients: [
      "Nonstick cooking spray",
      "8 ounces green beans, trimmed",
      "8 ounces Yukon gold potatoes, cut into 1/2-inch chunks",
      "1/2 cup Food Network Kitchen™ Inspirations Italian Herb & Garlic Dressing",
      "Kosher salt and freshly ground black pepper",
      "1 pound boneless, skinless chicken breasts",
      "1/2 cup sliced roasted red peppers",
      "1/2 small red onion, thinly sliced",
      "One 5-ounce package baby arugula or baby spinach",
      "1/2 cup crumbled goat cheese"
    ],
    directions: [
      "Preheat the oven to 425 degrees F. Coat a rimmed baking sheet with cooking spray and place in the oven while it preheats.",
      "Toss the green beans and potatoes in a large bowl with 2 tablespoons of the Italian Herb & Garlic Dressing. Sprinkle with salt and pepper. Spread on one side of the preheated baking sheet, leaving room for the chicken. Toss the chicken in the same bowl with 2 tablespoons of the remaining dressing. Sprinkle with salt and pepper. Lay the chicken breasts on the baking sheet. Roast until the potatoes and green beans are tender and browned and the chicken is cooked through, 18 to 20 minutes. Let the chicken rest for 5 minutes while you assemble the salad.",
      "Combine the red peppers, onions, green beans and potatoes in a large bowl. Drizzle with the remaining dressing and toss. Add the arugula and toss again. Divide the salad among 4 plates and sprinkle the goat cheese over top. Slice the chicken against the grain and divide among the plates."
    ],
    meta: {
      yield: 4,
      prep: 20,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "tortelliniSalad",
    shortname: "Herb & Garlic Tortellini Salad",
    name: "Warm Garlic & Herb Tortellini Salad",
    description:
      "Warm tortellini and roasted vegetables are elevated with a tangy Italian garlic-herb dressing along with a little salami and fresh herbs. Perfect for a weeknight dinner or as a side for a crowd.",
    image: "garlicHerbTortelliniSalad.jpg",
    category: "dressings",
    products: ["italianHerb"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "2 bell peppers (1 red, 1 yellow), cut into thick strips",
      "1 small bulb fennel, trimmed, halved, cored and thinly sliced, plus 1/4 cup chopped fronds",
      "1 red onion, sliced into 1/4-inch-thick rings",
      "2 tablespoons extra-virgin olive oil",
      "Kosher salt and freshly ground black pepper",
      "One 9-ounce package spinach or cheese tortellini",
      "One 5-ounce package baby spinach (about 8 cups)",
      "2 ounces thinly sliced salami, cut into thin strips",
      "1/2 cup Food Network Kitchen™ Inspirations Italian Herb & Garlic Dressing",
      "1/2 cup torn basil or flat-leaf parsley leaves"
    ],
    directions: [
      "Preheat the oven to 425 degrees F.",
      "Toss together the peppers, fennel, onions, oil, 1/2 teaspoon salt and a few grinds of pepper on a rimmed baking sheet. Bake, stirring occasionally, until the vegetables are tender and lightly browned, about 25 minutes.",
      "Meanwhile, bring a large pot of salted water to a boil. Add the tortellini and cook as the label directs; drain. Combine in a large bowl with the roasted vegetables and cool slightly.",
      "Add the spinach, salami and Italian Herb & Garlic Dressing to the bowl and toss. Season with salt and pepper. Sprinkle with the basil and fennel fronds.",
      "",
      ""
    ],
    meta: {
      yield: 4,
      prep: 25,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "baconCaesarSalad",
    shortname: "Bacon and Egg Caesar Salad",
    name: "Creamy Parmesan Caesar with Bacon & Egg",
    description:
      "Caesar salad, drizzled with a creamy Parmesan dressing, gets an upgrade thanks to crispy bacon and a sunny-side-up egg.",
    image: "baconEggCaesarSalad.jpg",
    category: "dressings",
    products: ["parmCaesar"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "3 strips bacon",
      "Nonstick cooking spray",
      "4 large eggs",
      "Kosher salt and freshly ground black pepper",
      "4 slices whole-grain or whole wheat bread",
      "1 small clove garlic, halved",
      "2 romaine hearts, trimmed and halved lengthwise",
      "1 cup cherry tomatoes, halved",
      "1/2 cup Food Network Kitchen ™ Inspirations Creamy Parmesan Caesar Dressing"
    ],
    directions: [
      "Cook the bacon in a large nonstick skillet over medium heat until golden and crispy, about 5 minutes per side. Drain on paper towels, then finely chop.",
      "Wipe out the skillet, coat with cooking spray and heat over medium heat. Crack the eggs into the skillet, cover and cook until desired doneness. Sprinkle the eggs with salt and pepper. Remove from the heat.",
      "Meanwhile, toast the bread, then rub one side of each slice with the garlic. Cut each slice in half. Put 2 toast halves on a plate and top each set with a romaine heart half and a quarter of the tomatoes. Top each with an egg and sprinkle with a quarter of the bacon. Repeat with the remaining toast, tomatoes, romaine, eggs and bacon. Drizzle each salad with 2 tablespoons of the Creamy Parmesan Caesar Dressing."
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 30,
      level: "easy"
    }
  },
  {
    id: "caesarPizza",
    shortname: " Caesar Salad Pizza",
    name: "Creamy Parmesan Caesar Salad Pizza",
    description:
      "A crunchy and creamy Caesar salad tops a fresh tomato pizza, giving you the best of both worlds.",
    image: "caesarSaladPizza.jpg",
    category: "dressings",
    products: ["parmCaesar"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "2 tablespoons extra-virgin olive oil",
      "1 1/2 pounds prepared pizza dough, at room temperature",
      "Kosher salt",
      "2 large ripe beefsteak tomatoes, cut into 6 to 8 thin slices",
      "1/4 cup finely grated Parmesan",
      "2 romaine hearts, cut into 1/2-inch thick and 1-inch wide pieces (about 8 cups)",
      "1/2 cup Food Network Kitchen™ Inspirations Creamy Parmesan Caesar Dressing",
      "1 cup shaved Parmesan ribbons (2 ounces) and 1 tablespoon coarse black pepper, for serving"
    ],
    directions: [
      "Preheat the oven to 450 degrees F.",
      "Drizzle 1 tablespoon of the oil in a 10-inch by 15-inch baking dish or on a rimmed baking sheet. Place the balls of dough side by side in the baking dish and pinch the edges together to make one large piece of dough. Press and stretch the dough so it fills the dish. (If using a baking sheet, press and stretch the dough into a 10- by 15-inch rectangle.)",
      "Brush the dough with the remaining 1 tablespoon oil. Sprinkle with salt. Arrange the tomato slices on the dough in a single layer, making sure that each bite will have a piece of tomato. Sprinkle with the Parmesan. Bake the pizza until the crust is golden brown, 25 to 30 minutes.",
      "Right before serving, toss the romaine with the Creamy Parmesan Caesar Dressing in a large bowl. Season with salt and pepper. Top the pizza with the salad. Sprinkle with Parmesan ribbons and coarse black pepper. Cut into pieces and serve."
    ],
    meta: {
      yield: 8,
      prep: 40,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "greekFetaSalad",
    name: "Feta & Herb Greek Salad with Chicken ",
    description:
      "Chicken marinated in a tangy feta and herb vinaigrette is the star of this Greek salad chock full of veggies and topped with crispy pita chips.",
    image: "greekSaladFetaHerbChicken.jpg",
    category: "dressings",
    products: ["greekFeta"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "1 pound boneless, skinless chicken thighs",
      "1 cup Food Network Kitchen ™ Inspirations Greek Feta Herb Vinaigrette",
      "Kosher salt and freshly ground black pepper",
      "2 romaine hearts, chopped",
      "1 cup grape tomatoes, halved",
      "1 small yellow bell pepper, cut into strips",
      "2 small Persian cucumbers, sliced",
      "1/2 cup pitted kalamata olives, halved",
      "1 cup coarsely crumbed pita chips",
      "1 cup crumbled feta"
    ],
    directions: [
      "Preheat the broiler.",
      "Toss the chicken in a large bowl with 1/4 cup of the Greek Feta Herb Vinaigrette and sprinkle with salt and pepper. Set aside while you assemble the salad.",
      "Lay the romaine on a large deep platter (or 4 wide, shallow bowls). Top with the tomatoes, bell pepper, cucumbers and olives.",
      "Arrange the chicken on a baking sheet and broil, turning once, until browned and cooked through, about 8 minutes per side. Let the chicken cool for a few minutes and then slice.",
      "Serve the warm chicken on the salad. Sprinkle with the pita chips and feta. Drizzle with the remaining vinaigrette."
    ],
    meta: {
      yield: 8,
      prep: 20,
      total: 20,
      level: "easy"
    }
  },
  {
    id: "saladPenne",
    name: 'Feta & Herb "Greek Salad" Penne',
    description:
      "Pasta and the ultimate diner salad mash-up. All the familiar flavors of your favorite salad pair with penne to make a satisfying weeknight dinner. A drizzle of creamy feta herb dressing brings all the ingredients together.",
    image: "greekSaladPenne.jpg",
    category: "dressings",
    products: ["greekFeta"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "Kosher salt",
      "12 ounces penne pasta (preferably spinach-flavored)",
      "2 tablespoons olive oil",
      "1 yellow bell pepper, cut into 1/2-inch strips",
      "One 15-ounce can chickpeas, drained and rinsed",
      "1 cup grape or cherry tomatoes, halved",
      "4 cloves garlic, thinly sliced",
      "1/3 cup pitted kalamata olives, rinsed and chopped",
      "3 cups tightly packed baby arugula or spinach (about 3 ounces)",
      "Freshly ground black pepper",
      "3/4 cup Food Network Kitchen™ Inspirations Greek Feta Herb Vinaigrette"
    ],
    directions: [
      "Bring a large pot of salted water to a boil. Add the pasta and cook as the label directs. Reserve 1/4 cup of the cooking water, then drain.",
      "Meanwhile, heat the oil in a large pot over medium-high heat. Add the peppers and cook, stirring occasionally, until just tender, about 3 minutes. Add the chickpeas, tomatoes, garlic and 1/2 teaspoon salt and cook, stirring occasionally, until the garlic is lightly browned and the tomatoes are just warmed through, about 3 minutes.",
      "Add the olives, pasta and the reserved pasta cooking water to the pot and cook for 1 minute. Remove from the heat and stir in the arugula until wilted. Season with salt and pepper. Transfer to a serving dish and drizzle with the Greek Feta Herb Vinaigrette."
    ],
    meta: {
      yield: 4,
      prep: 25,
      total: 25,
      level: "easy"
    }
  },
  {
    id: "kaleAppleSalad",
    shortname: "Sesame Ginger Kale Salad",
    name: "Sesame Ginger Kale and Apple Salad",
    description:
      "Sweet and crisp apple is a nice surprise in this Asian-inspired salad. It goes well with the crunchy wontons, toasted almonds and the slight bite from the just-sweet-enough sesame ginger dressing.",
    image: "kaleAppleSesameGingerSalad.jpg",
    category: "dressings",
    products: ["sesameGinger"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "1 sweet and crisp apple, such as Honeycrisp",
      "1 small orange",
      "4 cups tightly packed baby kale or spinach",
      "1/2 cup chow mein noodles or fried wonton strips",
      "1/4 cup sliced, skin-on almonds, toasted",
      "1/3 cup Food Network Kitchen™ Inspirations Asian Style Sesame Ginger Dressing",
      "Kosher salt and freshly ground black pepper"
    ],
    directions: [
      "Cut the apple into thin matchsticks. Peel and segment the orange and cut each segment in half crosswise.",
      "Put the kale in a large bowl. Add most of the apple, orange, chow mein noodles and almonds. Pour in the Asian Style Sesame Ginger Dressing and toss to coat. Season with salt and pepper. Top the salad with the reserved apple, orange, chow mein noodles and almonds."
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 30,
      level: "easy"
    }
  },
  {
    id: "shrimpRolls",
    shortname: "Sesame Ginger Shrimp Summer Rolls",
    name: "Sesame Ginger Shrimp Summer Rolls with Asian Slaw",
    description:
      "Serve these gingery shrimp and crunchy vegetable wraps with a sesame ginger dressing for dipping.",
    image: "shrimpSummerRolls.jpg",
    category: "dressings",
    products: ["sesameGinger"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "8 ounces large cooked, peeled and deveined shrimp, tails removed",
      "3/4 cup Food Network Kitchen ™ Inspirations Asian Style Sesame Ginger Dressing, plus more for dipping",
      "4 cups coleslaw mix",
      "4 scallions, finely chopped",
      "1 cup cilantro leaves",
      "1/2 cup chopped, roasted, salted peanuts",
      "8 round rice paper wrappers",
      "2 carrots, grated",
      "1 Persian cucumber, cut into matchsticks",
      "1 small red bell pepper, thinly sliced"
    ],
    directions: [
      "Halve the shrimp lengthwise and toss in a medium bowl with 1/3 cup of the Asian Style Sesame Ginger Dressing. Toss the coleslaw mix, scallions, cilantro and peanuts in a large bowl with the remaining dressing. Set aside while you assemble the summer rolls.",
      "Fill a wide, shallow bowl with warm water. Dip a wrapper in the water until pliable, about 15 seconds. Place on your work surface and lay a row of shrimp down the center, leaving about an inch on each side. Top with some of the carrots, cucumbers and peppers. Fold the sides in and then roll up like a burrito. Repeat with the remaining wrappers and ingredients, keeping the finished rolls covered with a damp paper towel as you work.",
      "Divide the slaw among 4 plates and place 2 summer rolls on each. Serve with the remaining dressing for dipping."
    ],
    meta: {
      yield: 4,
      prep: 25,
      total: 25,
      level: "easy"
    }
  },
  {
    id: "grilledMahiMahi",
    shortname: "Cuban-Style Grilled Mahi Mahi",
    name: "Cuban-style Orange Citrus Grilled Mahi Mahi",
    description:
      "A zippy orange citrus vinaigrette is used two ways in this recipe – to flavor mahi-mahi on the grill and as a drizzle over smoky black beans and rice.",
    image: "grilledMahiMahiCitrusVinaigrette.jpg",
    category: "dressings",
    products: ["cubanCitrus"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "Four 4-ounce mahi-mahi fillets",
      "Kosher salt and freshly ground black pepper",
      "3/4 cup Food Network Kitchen™ Inspirations Cuban Style Orange Citrus Vinaigrette, plus more for drizzling",
      "Vegetable oil, for oiling the grill grates",
      "3 slices bacon, cut crosswise into 1/2-inch strips",
      "1 small red bell pepper, diced",
      "1/2 small red onion, diced",
      "2 cups long-grain white rice",
      "1/2 teaspoon ground cumin",
      "One 14.5-ounce can black beans, drained and rinsed",
      "1/4 cup plantain chips, crushed",
      "1 lime, quartered"
    ],
    directions: [
      "Prepare an outdoor grill for medium-high heat.",
      "Sprinkle the mahi-mahi with salt and pepper. Coat in 1/4 cup of the Cuban Style Orange Citrus Vinaigrette in a shallow bowl or baking dish. Let marinate at room temperature for 10 minutes.",
      "Meanwhile, add the bacon to a medium saucepan over medium heat and cook, stirring, until crispy, about 4 minutes. Use a slotted spoon to remove the bacon pieces, leaving the drippings in the pan. Add the peppers and onions and cook, stirring, until soft, about 4 minutes. Add the rice, 3 cups water, cumin and a large pinch of salt. Bring to a simmer, cover and reduce the heat. Cook until the rice is tender and the all water has been absorbed, 15 to 20 minutes. Stir in the beans and bacon pieces.",
      "Brush the grill grates generously with oil. Place the fish on the grill, rounded-side down, and leave it until you can lift the fish without it sticking to the grill and there are distinct grill marks, about 5 minutes. (Test it by gently lifting a corner – if it sticks, cook it a bit longer and try again.) Carefully turn the fish over and cook until firm to the touch, about another 5 minutes.",
      "Divide the rice and beans among 4 plates. Top each with a piece of mahi-mahi. Drizzle with the remaining vinaigrette. Sprinkle with crushed plantains and serve each with a lime quarter.",
      ""
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 30,
      level: "easy"
    }
  },
  {
    id: "avocadoToastSalad",
    shortname: "Orange Citrus Avocado Toast Salad",
    name: "Cuban-Style Orange Citrus Avocado Toast Salad",
    description:
      "Avocado toast meets salad. An orange citrus vinaigrette has just the right amount of brightness to balance the rich avocado and salty pop of feta.",
    image: "avocadoToastSalad.jpg",
    category: "dressings",
    products: ["cubanCitrus"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "4 slices whole-grain or whole wheat bread",
      "2 tablespoons sliced skin-on almonds",
      "1 large avocado, halved, pitted, scooped and quartered",
      "1/3 cup Food Network Kitchen™ Inspirations Cuban Style Orange Citrus Vinaigrette",
      "4 cups mixed baby greens",
      "1/3 cup crumbled feta cheese",
      "5 radishes, very thinly sliced",
      "Kosher salt",
      "1 small orange, cut into 8 wedges"
    ],
    directions: [
      "Preheat the oven to 350 degrees F.",
      "Arrange the bread and almonds on a baking sheet and bake, flipping the bread once, until it's toasted and crunchy and the almonds are golden, about 10 minutes. Set aside to cool.",
      "Mash the avocado with 2 tablespoons of the Cuban Style Orange Citrus Vinaigrette in a small bowl. Spread some of the avocado mixture onto each piece of toast. Quarter each piece of toast and arrange the pieces on 4 plates with the points facing out to make a square.",
      "Toss together the greens, toasted almonds, feta, radishes and remaining vinaigrette in a large bowl. Season with salt. Put a mound of salad in the center of each avocado toast square. Garnish each salad with 2 orange wedges.",
      "",
      ""
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "salmonCakes",
    name: "Dijon Balsamic Salmon Cakes",
    description:
      "A mustard-based balsamic vinaigrette does double duty as a flavoring for moist salmon cakes and a dressing for mixed greens that are served alongside.",
    image: "salmonCakes.jpg",
    category: "dressings",
    products: ["frenchBalsamic"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "Three 7.5-ounce cans boneless salmon, drained",
      "2 tablespoons mayonnaise",
      "1 teaspoon lemon zest, plus wedges for serving",
      "1 large egg, lightly beaten",
      "1 small jar roasted red peppers, finely chopped",
      "1/2 cup plain breadcrumbs",
      "1/3 cup Food Network Kitchen™ Inspired French Style Dijon Balsamic Vinaigrette",
      "Kosher salt and freshly ground black pepper",
      "3 tablespoons olive oil",
      "5 ounces mixed baby greens"
    ],
    directions: [
      "Preheat the oven to 400 degrees F.",
      "Mix together the salmon, mayonnaise, lemon zest, egg, roasted red peppers, 3 tablespoons of the breadcrumbs, 1 tablespoon of the French Style Dijon Balsamic Vinaigrette, 1/2 teaspoon salt and a few grinds of pepper in a large bowl. Gently form into eight 3/4-inch-thick patties and freeze until just firm, about 10 minutes.",
      "Put the remaining breadcrumbs in a shallow bowl. Press the salmon cakes in the breadcrumbs to coat both sides. Heat the oil in a large ovenproof nonstick skillet over medium-high heat. Add the salmon cakes and cook until golden brown, 3 to 4 minutes per side. Transfer the skillet to the oven and bake until the cakes are heated through, 6 to 8 minutes.",
      "Toss the greens with the remaining vinaigrette in a medium bowl. Season with salt and pepper. ",
      "Divide the salmon cakes among 4 plates (2 per plate). Add a mound of salad to each plate and a lemon wedge."
    ],
    meta: {
      yield: 4,
      prep: 40,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "steakBlueCheese",
    shortname: "Dijon Balsamic Steak Salad",
    name: "Dijon Balsamic Steak Salad with Blue Cheese Butter",
    description:
      "Inexpensive steaks get an upgrade from a Dijon balsamic vinaigrette and a dollop of blue cheese butter. The vinaigrette also makes an earthy, tangy dressing for a crunchy celery salad.",
    image: "dijonBalsamicSteak.jpg",
    category: "dressings",
    products: ["frenchBalsamic"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "1/2 small red onion, thinly sliced",
      "Four 4-ounce top blade steaks",
      "Kosher salt and freshly ground black pepper",
      "1/3 cup Food Network Kitchen ™ Inspirations French Style Dijon Balsamic Vinaigrette",
      "3 tablespoons crumbled blue cheese",
      "2 tablespoons unsalted butter, at room temperature",
      "3 tablespoons chopped flat-leaf parsley",
      "4 stalks celery, thinly sliced",
      "1 tablespoon olive oil"
    ],
    directions: [
      "Soak the onions in a bowl of cold water for 10 minutes (this helps remove some of the pungent bite).",
      "Pierce the steaks with a fork and sprinkle with salt and pepper. Coat them in 3 tablespoons of the French Style Dijon Balsamic Vinaigrette in a shallow bowl or baking dish. Set aside while you prepare the blue cheese butter and salad.",
      "Mash the blue cheese, butter and 1 tablespoon of the parsley in a small bowl and season with salt and pepper.",
      "Drain the onion and pat dry. Toss with the celery and the remaining 2 tablespoons parsley in another bowl. Season with salt and pepper.",
      "Heat the oil in a large cast-iron skillet over high heat. Cook the steaks until browned on the bottom, 3 to 5 minutes. Flip and continue to cook 3 to 5 more minutes for medium rare. Transfer to a plate and let rest 5 minutes.",
      "Divide the celery salad among 4 plates. Top each with a steak and drizzle with any pan juices or collected juices on the plate. Top each steak with a mound of blue cheese butter. Drizzle with the remaining vinaigrette."
    ],
    meta: {
      yield: 4,
      prep: 35,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "chickenTacos",
    name: "Cilantro Lime Chicken Tacos",
    description:
      "A cilantro lime vinaigrette has two jobs in a weeknight taco recipe. First, it's the marinade for the pan seared chicken filling. Then it turns sour cream into a special topping.",
    image: "chickenTacosCilantroLimeTacos.jpg",
    category: "dressings",
    products: ["cilantroLime"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "1 pound boneless, skinless chicken thighs",
      "Kosher salt and freshly ground black pepper",
      "2/3 cup Food Network Kitchen ™ Inspirations Mexican Style Cilantro Lime Vinaigrette",
      "1/4 cup sour cream",
      "1 tablespoon vegetable oil",
      "16 corn tortillas",
      "Shredded lettuce, diced red onion, sliced radishes, guacamole and whole cilantro leaves, for serving"
    ],
    directions: [
      "Sprinkle the chicken with salt and pepper in a large bowl. Then toss with 1/2 cup of the Mexican Style Cilantro Lime Vinaigrette. Marinate for 10 minutes.",
      "Meanwhile, stir together the sour cream with the remaining 2 tablespoons vinaigrette.",
      "Heat the oil in a large nonstick skillet over medium-high heat. Add the chicken along with the marinade and cook until slightly browned and cooked through, about 7 minutes per side. Transfer to a cutting board and chop. Season with salt.",
      "Warm the tortillas as the label directs. Using 2 stacked tortillas per taco, fill with the chicken, top with the cilantro-lime sour cream and the toppings of your choice."
    ],
    meta: {
      yield: 4,
      prep: 40,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "chickenSandwich",
    shortname: "Cilantro Lime Chicken Sandwich",
    name: "Cilantro Lime Grilled Chicken Sandwich",
    description:
      "A tangy cilantro lime vinaigrette is both a marinade and sauce for these Mexican-inspired grilled chicken sandwiches.",
    image: "grilledMexicanChickenSandwich.jpg",
    category: "dressings",
    products: ["cilantroLime"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "1 pound boneless, skinless chicken breasts",
      "3/4 cup Food Network Kitchen™ Inspirations Mexican Style Cilantro Lime Vinaigrette",
      "4 slices bacon",
      "Vegetable oil, for oiling the grill grates",
      "Kosher salt and freshly ground black pepper",
      "1/4 cup chipotle mayonnaise (or other spicy mayonnaise)",
      "4 panini rolls, split",
      "1 avocado, sliced",
      "1 tomato, sliced",
      "1 cup loosely packed fresh cilantro leaves",
      "4 small radishes, thinly sliced"
    ],
    directions: [
      "Combine the chicken breasts and 1/2 cup of the Mexican Style Cilantro Lime Vinaigrette in a resealable plastic bag. Let marinate at room temperature for 15 minutes.",
      "Meanwhile, cook the bacon in a large skillet over medium heat until crisp, about 5 minutes per side. Drain on paper towels.",
      "Prepare an outdoor grill or preheat a grill pan for medium-high heat.",
      "Oil the grills grate or grill pan. Remove the chicken from the marinade. Sprinkle with salt and pepper. Grill the chicken, turning once, until cooked through, about 4 minutes per side, depending on thickness.",
      "Spread the mayonnaise on the cut surfaces of the rolls. Slice the chicken and add to the rolls. Break the bacon in half and place on top of the chicken. Top with avocado and tomato slices, cilantro leaves and radishes. Drizzle each sandwich with 1 tablespoon of the remaining vinaigrette. Press the tops on the sandwiches."
    ],
    meta: {
      yield: 4,
      prep: 35,
      total: 35,
      level: "easy"
    }
  },
  {
    id: "chickenTacoSalad",
    name: "Mango Chipotle Chicken Taco Salad",
    description:
      "A sweet and spicy vinaigrette plays double duty in this taco salad. Not only is it a salad dressing but it also brings beans and corn together into a quick salsa for topping.",
    image: "chickenTacoSalad.jpg",
    category: "dressings",
    products: ["mangoChipotle"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "One 14.5-ounce can black beans, rinsed and drained",
      "1 cup frozen fire-roasted corn, thawed",
      "2 plum tomatoes, chopped",
      "3/4 cup Food Network Kitchen™ Inspirations Mexican Style Mango Chipotle Vinaigrette, plus more for serving",
      "1/2 head iceberg lettuce, shredded (about 8 cups)",
      "2 cups shredded rotisserie chicken (skin removed)",
      "1 cup grated sharp Cheddar (about 4 ounces)",
      "2 cups tortilla chips, crushed"
    ],
    directions: [
      "Toss together the beans, corn, tomatoes and 3 tablespoons of the Mexican Style Mango Chipotle Vinaigrette in a large bowl. Let sit, tossing occasionally, until juicy, about 10 minutes.",
      "Divide the lettuce among 6 bowls and top with the bean mixture and juices, chicken, cheese and tortilla chips. Drizzle with the remaining vinaigrette."
    ],
    meta: {
      yield: 6,
      prep: 25,
      total: 25,
      level: "easy"
    }
  },
  {
    id: "quinoaBowl",
    name: "Mango Chipotle Quinoa Bowls",
    description:
      "A satisfying Mexican-inspired grain bowl gets a little spicy and sweet thanks to a mango chipotle vinaigrette.",
    image: "mexicanQuinoaBowls.jpg",
    category: "dressings",
    products: ["mangoChipotle"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "1 1/3 cups red quinoa, rinsed well",
      "3/4 cup Food Network Kitchen ™ Inspirations Mexican Style Mango Chipotle Vinaigrette, plus more for drizzling",
      "1/4 cup cilantro leaves, roughly chopped, plus whole leaves for garnish",
      "Kosher salt and freshly ground black pepper",
      "1/2 cup rinsed and drained canned black beans",
      "1/4 cup roasted and salted almonds or peanuts, crushed",
      "1/4 cup salsa",
      "1/4 cup sour cream",
      "2 large radishes, sliced into thin rounds",
      "1 avocado, diced"
    ],
    directions: [
      "Prepare the quinoa according to package directions. Stir in the Mexican Style Mango Chipotle Vinaigrette and chopped cilantro. Season with salt and pepper.",
      "Divide the quinoa among 6 bowls and top each with the beans, nuts, salsa, sour cream, radish and avocado in neat piles or rows. Drizzle each bowl with a little more vinaigrette. Garnish with cilantro leaves."
    ],
    meta: {
      yield: 6,
      prep: 25,
      total: 40,
      level: "easy"
    }
  },

  //sauces recipes
  {
    id: "grilledPork",
    shortname: "Herb & Balsamic Grilled Pork",
    name: "Herb & Balsamic Grilled Pork with Arugula and Grape Salad",
    description:
      "Simple boneless pork chops get an upgrade with a quick marinade in a sweet and tangy herb and balsamic cooking sauce. A spinach and grape salad sprinkled with blue cheese makes it special.",
    image: "grilledPorkSpinachGrape.jpg",
    category: "sauces",
    products: ["tuscanHerb"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "1 medium shallot, thinly sliced",
      "Four 4-ounce boneless pork chops",
      "Kosher salt and freshly ground black pepper",
      "1/3 cup Food Network Kitchen™ Inspirations Tuscan Style Herb & Balsamic Cooking Sauce",
      "1 tablespoon olive oil, plus more for oiling the grill grates",
      "3 cups tightly packed baby spinach (about 3 ounces)",
      "1 cup red seedless grapes, halved",
      "1 tablespoon lemon juice",
      "1/2 teaspoon honey",
      "1/4 cup crumbled blue cheese"
    ],
    directions: [
      "Prepare an outdoor grill for medium-high heat. Soak the shallots in cold water for 10 minutes (this helps remove some of the pungent bite). Drain.",
      "Pierce the pork chops all over with a fork. Put in a shallow dish and sprinkle all over with salt and pepper. Coat the pork in all but 2 tablespoons of the Tuscan Style Herb & Balsamic Cooking Sauce and set aside to marinate at room temperature for 10 minutes.",
      "Oil the grill grates and grill the pork until cooked through but still moist, basting occasionally with the reserved cooking sauce, about 4 minutes per side. Let the pork rest.",
      "Meanwhile, add the spinach, grapes and shallots to a large bowl. Drizzle in the oil, lemon juice and honey and toss. Season with salt and pepper.",
      "Arrange the pork chops on a serving platter. Top with the spinach and grape salad and sprinkle with the blue cheese."
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "chickenRavioli",
    shortname: "Balsamic Chicken & Ravioli Skillet",
    name: "Herb & Balsamic Chicken & Ravioli Skillet",
    description:
      "Think of this weeknight meal as an Italian-inspired chicken and dumplings. Simmered in an herb and balsamic sauce, it's a recipe small on ingredients and big on flavor.",
    image: "skilletChickenRavioli.jpg",
    category: "sauces",
    products: ["tuscanHerb"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "Kosher salt",
      "One 9-ounce package cheese ravioli",
      "2 tablespoons olive oil, plus more for drizzling",
      "1 pound skinless, boneless chicken breasts, cut into chunks",
      "Freshly ground black pepper",
      "8 ounces white mushrooms, quartered",
      "1/2 cup Food Network Kitchen™ Inspirations Tuscan Style Herb & Balsamic Cooking Sauce",
      "1/3 cup flat-leaf parsley leaves, chopped",
      "3 tablespoons grated Parmesan",
      "Large pinch crushed red pepper"
    ],
    directions: [
      "Bring a pot of salted water to a boil. Add the ravioli and cook as the label directs. Drain, then drizzle with oil and toss. Set aside and keep warm.",
      "Meanwhile, sprinkle the chicken with salt and pepper. Heat 1 tablespoon of the oil in a large nonstick skillet over medium-high heat. Add the chicken and cook, undisturbed, until beginning to brown, about 2 minutes. Continue to cook, stirring, about 1 more minute. Transfer to a plate (the chicken will not be cooked all the way through at this point).",
      "Heat the remaining 1 tablespoon oil in the skillet. Add the mushrooms and cook, undisturbed, until browned in spots, about 2 minutes. Sprinkle with salt and continue to cook, stirring, until softened, about 3 more minutes. Return the chicken and any collected juices to the skillet. Add the Tuscan Style Herb & Balsamic Cooking Sauce, half of the parsley, 2 tablespoons of the Parmesan and 2 tablespoons water. Bring to a simmer and cook, stirring occasionally, until the chicken is cooked through and the sauce has thickened, about 4 minutes.",
      "Nestle the ravioli into the skillet. Sprinkle with the remaining parsley and Parmesan. Sprinkle with crushed red pepper."
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 30,
      level: "easy"
    }
  },
  {
    id: "teriyakiSalmon",
    shortname: "Teriyaki Salmon",
    name: "Teriyaki Salmon with Grilled Scallions and Avocado Cucumber Salad",
    description:
      "Salmon and scallions are brushed with a flavorful teriyaki sauce and served with a vinegary avocado cucumber salad.",
    image: "teriyakiSalmonGrilledScallions.jpg",
    category: "sauces",
    products: ["teriyaki"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "2 tablespoons rice vinegar",
      "1/2 cup Food Network Kitchen™ Inspirations Japanese Style Teriyaki Cooking Sauce",
      "Four 4-ounce center-cut salmon fillets",
      "Vegetable oil, for brushing and oiling the grill grates",
      "1 bunch scallions, trimmed",
      "Kosher salt and freshly ground black pepper",
      "2 Persian cucumbers, cut into half moons",
      "1 avocado, cubed",
      "2 teaspoons toasted sesame seeds"
    ],
    directions: [
      "Preheat an outdoor grill to medium heat.",
      "Stir together the rice vinegar and 1/4 cup of the Japanese Style Teriyaki Cooking Sauce in a medium bowl.",
      "Oil the grill grates. Brush the salmon and scallions with oil. Sprinkle with salt and pepper. Place the salmon on the grill, flat-side down, and brush the tops with some of the remaining cooking sauce. Place the scallions on the grill and brush with some of the remaining cooking sauce. Cover and cook until the scallions are charred and tender, about 3 minutes. Flip the fish, brush with the remaining cooking sauce and continue to cook until the fish is almost cooked through (it will cook more after you remove it from the grill), 4 to 5 minutes per side. Remove the salmon and scallions to a cutting board. Coarsely chop the scallions.",
      "Add the cucumber, avocado and scallions to the bowl with the vinegar sauce and toss. Mound the salad onto 4 serving plates. Plate the salmon next to the salad. Sprinkle with the sesame seeds."
    ],
    meta: {
      yield: 4,
      prep: 25,
      total: 25,
      level: "easy"
    }
  },
  {
    id: "teriyakiChicken",
    name: "Teriyaki Chicken Fried Rice",
    description:
      "Cancel the takeout order. Chicken, veggies and cooked rice coated in a teriyaki sauce make a tasty and hearty dinner that gets to the table fast.",
    image: "teriyakiChickenFriedRice.jpg",
      videoURL: "/videos/Stirfry.mp4",
    category: "sauces",
    products: ["teriyaki"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "2 large eggs",
      "Kosher salt",
      "2 tablespoons vegetable oil",
      "1 boneless, skinless chicken breast (about 8 ounces), diced",
      "1 cup frozen peas and carrots, thawed",
      "1 small red bell pepper, diced",
      "1 bunch scallions, chopped",
      "1 tablespoon grated fresh ginger",
      "3 cups cooked white rice, cold or at room temperature",
      "1/2 cup Food Network Kitchen™ Inspirations Japanese Style Teriyaki Cooking Sauce"
    ],
    directions: [
      "Whisk the eggs with a pinch of salt in a small bowl. Heat 1 tablespoon of the oil in a large nonstick skillet over medium-high heat. Add the eggs and cook, without stirring, until almost set, about 1 minute. Flip the egg pancake with a rubber spatula and cook until just set on the other side, about 1 minute. Transfer to a cutting board and cut into thin strips.",
      "Heat the remaining 1 tablespoon oil in the same skillet over high heat. Add the chicken and cook, stirring, until almost cooked through, about 2 minutes. Add the peas and carrots, peppers and scallions and continue to cook, stirring, until crisp-tender, about 2 minutes. Add the ginger and cook, stirring, 1 minute. Add the rice and Japanese Style Teriyaki Cooking Sauce and cook, stirring, until warmed through. Stir in the egg strips and divide among 4 bowls."
    ],
    meta: {
      yield: 4,
      prep: 20,
      total: 20,
      level: "easy"
    }
  },
  {
    id: "jerkPulledPork",
    shortname: "Pulled Pork Jerk Sandwiches",
    name: "Slow Cooker Pulled Pork Jerk Sandwiches",
    description:
      "Give ordinary slow cooker pulled pork a Jamaican jerk twist. Perfect for a weeknight dinner (with leftovers) or as sliders for a crowd.",
    image: "slowCookerJerkPulledPorkSandwiches.jpg",
    category: "sauces",
    products: ["jerk"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "One 2-pound boneless pork shoulder",
      "Kosher salt and freshly ground black pepper",
      "3/4 cup Food Network Kitchen™ Inspirations Jamaican Style Jerk Cooking Sauce",
      "1/4 cup apple cider vinegar",
      "1/2 onion, roughly chopped",
      "4 cloves garlic, smashed",
      "8 potato hamburger rolls or potato slider rolls",
      "2 cups prepared coleslaw",
      "1/2 cup mango chutney",
      "8 ounces sweet potato chips"
    ],
    directions: [
      "Sprinkle the pork all over with salt and pepper. Transfer to a 6- to 8-quart slow cooker insert. Add the Jamaican Style Jerk Cooking sauce, vinegar, onions and garlic. Cover and cook on low for 8 hours.",
      "Remove the pork from the slow cooker and strain the cooking liquid into a small saucepan. Bring the cooking liquid to a boil and then lower to a simmer and cook until reduced by about half.",
      "Meanwhile, shred the pork with a fork. Add the reduced cooking liquid to the shredded pork and season with salt and pepper.",
      "Serve the pulled pork on the rolls with coleslaw, mango chutney and sweet potato chips on the side."
    ],
    meta: {
      yield: 8,
      prep: 30,
      total: 510,
      level: "easy"
    }
  },
  {
    id: "jerkChicken",
    name: "Jerk Chicken with Pineapple Slaw",
    description:
      "Getting your spicy chicken fix got easier by using a jerk cooking sauce. Grilling over indirect heat on an outdoor grill ensures that your chicken will be moist on the inside without being charred to a crisp on the outside.",
    image: "jerkChickenPineappleSlaw.jpg",
    category: "sauces",
    products: ["jerk"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "Vegetable oil, for oiling the grill grates",
      "Four 8-ounce skin-on, bone-in chicken breast halves",
      "Kosher salt and freshly ground black pepper",
      "1 1/4 cups Food Network Kitchen™ Inspirations Jamaican Style Jerk Cooking Sauce",
      "4 cups coleslaw mix",
      "2 tablespoons mayonnaise",
      "2 tablespoons roasted, salted cashews, chopped",
      "2 tablespoons cilantro leaves, chopped",
      "Juice of half a lemon",
      "A quarter of a pineapple, core removed and diced",
      "2 cups cooked warm white rice, for serving"
    ],
    directions: [
      "Prepare an outdoor grill for medium-high heat on one side.",
      "Oil the grill grates. Sprinkle the chicken all over with salt and pepper. Grill over direct heat until golden and crisp, about 5 minutes per side. Transfer to a large bowl filled with 1 cup of the Jamaican Style Jerk Cooking Sauce and toss to coat. Return the chicken to the indirect side of the grill, cover and cook, basting once with the remaining cooking sauce, until the chicken reaches and internal temperature of 165 degrees F, 25 to 30 minutes. Transfer the chicken back to the direct side, skin side-down, and cook until slightly charred, about 5 minutes.",
      "Meanwhile, combine the coleslaw mix, mayonnaise, cashews, cilantro, lemon juice and pineapple in another large bowl. Stir to combine and season with salt and pepper.",
      "Serve the chicken with the pineapple slaw and rice.",
      "",
      ""
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 45,
      level: "easy"
    }
  },
  {
    id: "thaiRibs",
    shortname: "Sweet & Spicy Thai Style Ribs",
    name: "Slow Cooker Sweet & Spicy Thai Style Ribs",
    description:
      "Let your slow cooker do all the work. These sweet and spicy Thai-inspired ribs are perfect for hectic weeknight dinners.",
    image: "sweetSpicyThaiRibs.jpg",
    category: "sauces",
    products: ["sweetSpicyChili"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "One 3- to 4-pound rack pork spare or back loin ribs, halved",
      "Kosher salt and freshly ground black pepper",
      "3/4 cup Food Network Kitchen™ Inspirations Thai Style Sweet & Spicy Chili Cooking Sauce",
      "Chopped cilantro, chopped roasted and salted peanuts and lime wedges, for serving"
    ],
    directions: [
      "Sprinkle the ribs all over with salt and pepper. Brush the ribs with 1/2 cup of the Thai Style Sweet & Spicy Chili Cooking Sauce. Transfer to a 6- to 8-quart slow cooker insert. Cover and cook on low for 8 hours.",
      "Preheat the broiler and line a baking sheet with foil.",
      "Place each rib rack half, bone-side down, on the prepared baking sheet. Brush with the remaining 1/4 cup cooking sauce. Broil until the glaze is bubbling and browned, 3 to 5 minutes.",
      "Slice the ribs between the bones. Transfer to a platter and sprinkle with cilantro and peanuts. Squeeze lime juice over the ribs.",
      "",
      ""
    ],
    meta: {
      yield: 6,
      prep: 20,
      total: 510,
      level: "easy"
    }
  },
  {
    id: "thaiShrimp",
    name: "Sweet & Spicy Thai Shrimp Stir Fry",
    description:
      "Thanks to the Thai Sweet & Spicy Chili Cooking Sauce, this simple shrimp stir-fry doesn't require a laundry list of ingredients.",
    image: "sweetSpicyThaiShrimp.jpg",
    category: "sauces",
    products: ["sweetSpicyChili"], //list of specific products this recipe pairs with
    featured: true,
    ingredients: [
      "3 tablespoons peanut oil",
      "3 cloves garlic, chopped",
      "One 2-inch piece ginger, chopped",
      "12 ounces large peeled and deveined shrimp, tails removed",
      "1 small red onion, cut into 1/4-inch-thick strips",
      "1 medium yellow bell pepper, cut into 1/4-inch-thick strips",
      "1/2 cup Food Network Kitchen™ Inspirations Thai Style Sweet & Spicy Chili Cooking Sauce",
      "Kosher salt",
      "Juice from half a lime",
      "1/2 cup torn basil and/or mint leaves",
      "2 cups cooked, warm jasmine rice, for serving"
    ],
    directions: [
      "Heat the oil in a large nonstick skillet or wok over high heat. Add the garlic and ginger and cook, stirring, until fragrant, about 30 seconds. Add the shrimp and stir fry until pink but still translucent in the middle, about 2 minutes.",
      "Transfer the shrimp to a medium bowl with a slotted spoon. Add the onions and peppers to the skillet and cook, stirring, until lightly browned, about 3 minutes.",
      "Return the shrimp to the skillet along with the Thai Style Sweet & Spicy Chili Cooking Sauce. Cook, stirring, until the sauce glazes the shrimp, about 1 minute.",
      "Remove the skillet from the heat, season with salt, add the lime juice and sprinkle with the herbs. Serve with rice."
    ],
    meta: {
      yield: 4,
      prep: 30,
      total: 30,
      level: "easy"
    }
  },
  {
    id: "flankSteak",
    shortname: "Gochujang Flank Steak",
    name: "Gochujang Flank Steak with Rice Noodle Salad",
    description:
      "Spicy Korean gochujang sauce wakes up ordinary flank steak. It's served with rice noodle salad and pickled shallots.",
    image: "flankSteakRiceNoodleSalad.jpg",
    category: "sauces",
    products: ["gochujang"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "4 ounces stir-fry rice noodles",
      "1/2 cup rice vinegar",
      "1 teaspoon honey",
      "Kosher salt",
      "1 shallot, thinly sliced",
      "1 pound flank steak",
      "Freshly ground black pepper",
      "3/4 cup Food Network Kitchen™ Inspirations Korean Gochujang Cooking Sauce, plus more for serving",
      "2 scallions, thinly sliced",
      "1 medium carrot, grated",
      "1 teaspoon sesame oil"
    ],
    directions: [
      "Bring a large pot of water to a boil. Cook the noodles according to package instructions. Drain, rinse under cold water and set aside.",
      "Meanwhile, whisk together the vinegar, honey and a large pinch of salt in a small microwave-safe bowl. Add the shallot and toss to coat. Microwave for 1 minute. Let cool and then drain, reserving 1/4 cup of the pickling liquid.",
      "Position an oven rack 5 to 6 inches below the broiler and preheat. Line a baking sheet with foil",
      "Put the flank steak on the prepared baking sheet and sprinkle all over with salt and pepper. Rub the steak with 1/4 cup of the Korean Gochujang Cooking Sauce and let marinate at room temperature for 15 minutes.",
      "Broil the steak (without turning) until nicely browned and firm, with some give when pressed in the thickest part, 6 to 8 minutes for medium rare. Let rest for 5 minutes.",
      "Toss the rice noodles with the scallions, carrots, sesame oil and reserved pickling liquid in a medium bowl. Season with salt and pepper.",
      "Slice the steak thinly against the grain. Scatter the pickled shallots over top and serve with the rice noodle salad and remaining cooking sauce on the side."
    ],
    meta: {
      yield: 4,
      prep: 40,
      total: 40,
      level: "easy"
    }
  },
  {
    id: "riceBowls",
    name: "Korean-Style Rice Bowls",
    description:
      "Gochujang is a crimson red Korean sauce that is slightly spicy with a miso-like flavor. It's the perfect flavoring for these easy rice bowls topped with avocado, bacon and a fried egg.",
    image: "koreanStyleRiceBowls.jpg",
    category: "sauces",
    products: ["gochujang"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
      "4 cups cooked brown rice",
      "3/4 cup Food Network Kitchen™ Inspirations Korean Gochujang Cooking Sauce",
      "Kosher salt",
      "4 strips bacon",
      "1 teaspoon vegetable oil",
      "4 large eggs",
      "1 avocado, sliced",
      "2 scallions, sliced",
      "2 teaspoons toasted sesame oil",
      "2 teaspoons black sesame seeds"
    ],
    directions: [
      "Toss together the rice and 1/2 cup of the Korean Gochujang Cooking Sauce in a medium bowl. Cover and microwave until hot, stirring halfway through, about 4 minutes. Season with salt.",
      "Meanwhile, cook the bacon in a large nonstick skillet over medium heat until browned and crispy, 4 to 5 minutes per side. Transfer to a paper-towel-lined plate to drain and then roughly chop.",
      "Wipe out the skillet, add the oil and place it over medium-high heat. Crack the eggs into the skillet and sprinkle each with a little salt. Cover and cook until desired doneness. Remove from the heat.",
      "Divide the hot rice among 4 bowls. Top each with an egg, avocado slices, bacon, the remaining cooking sauce and scallions. Drizzle each with 1/2 teaspoon of the sesame oil and sprinkle with the sesame seeds."
    ],
    meta: {
      yield: 4,
      prep: 25,
      total: 25,
      level: "easy"
    }
  },
  {
    id: "cheesyHasselbackChicken",
    name: "Cheesy Hasselback Chicken",
    description:
      "Simmered in tangy herb and garlic dressing, these cheese-stuffed breasts are an easy, elegant weeknight dinner.",
    image: "hasselbackChicken.jpg",
      videoURL: "/videos/Final2_FN_KRAFT-Hasselback-Chicken.mp4",
    category: "dressings",
    products: ["italianHerb"], //list of specific products this recipe pairs with
    featured: false,
    ingredients: [
        "4 boneless, skinless chicken breasts",
        "1/2 cup Food Network Kitchen™ Inspirations Italian Herb & Garlic Dressing",
        "2 plum tomatoes, cut in half lengthwise and thinly sliced",
        "1 cup sliced sun-dried tomatoes",
        "4 thick slices provolone cheese (about 4 ounces), cut into quarters",
        "Green salad, for serving"
    ],
    directions: [
        "Preheat the oven to 400 degrees F.",
        "Make 8 crosswise cuts along each chicken breast, slicing two-thirds of the way through (be careful not to cut all the way through; see Cook's Note). Transfer the breasts to a 9-by-13-inch baking dish and pour the Italian Herb & Garlic Dressing over them.",
        "Fill the first slit on each breast with 1 half-moon slice of fresh tomato and a couple pieces of sun-dried tomato. Fill the next slit with 1 piece of cheese. Fill the remaining slits on each breast, alternating between the tomatoes and cheese.",
    "Bake until the chicken is cooked through and the juices run clear, 25 to 30 minutes. Serve warm with a green salad."
    ],
    meta: {
      yield: 4,
      prep: 10,
      total: 40,
      level: "easy"
    }
  },
    {
        id: "thaiChickenLettuceWraps",
        name: "Thai Chicken Lettuce Wraps",
        description:
            "Made from a quick stir-fry of chicken and Thai Style Sweet & Spicy Chili Cooking Sauce, these lettuce cups are easy to personalize. Put out peanuts, onions, peppers, plus herbs like basil or cilantro if you have them, and let everyone at the table build their own meal.",
        image: "thaiChickenLettuceWraps.jpg",
        videoURL: "/videos/Thai_Chicken_Lettuce_Wraps.mp4",
        category: "sauces",
        products: ["sweetSpicyChili"], //list of specific products this recipe pairs with
        featured: false,
        ingredients: [
            "1 tablespoon vegetable oil",
            "1 pound ground chicken",
            "1 cup Food Network Kitchen™ Inspirations Thai Style Sweet & Spicy Chili Cooking Sauce",
            "12 large Boston lettuce leaves (from 2 heads of lettuce)",
            "1/4 cup dry-roasted peanuts, chopped",
            "1/2 small red onion, sliced",
            "1 jalapeno, seeded and sliced",
            "Rice, for serving"

        ],
        directions: [
            "Heat the oil in a medium nonstick skillet over medium-high heat until hot but not smoking. Add the chicken and cook, breaking it up with a wooden spoon, until no longer pink, about 5 minutes. Turn the heat to medium low and stir in the Thai Style Sweet & Spicy Chili Cooking Sauce. Bring to a simmer and cook until the chicken is cooked through, about 3 minutes.",
            "Divide the meat and sauce among the lettuce leaves and top with the peanuts, onions and jalapenos. Serve with rice on the side."
        ],
        meta: {
            yield: 4,
            prep: 15,
            total: 50,
            level: "easy"
        },
    },
    {
        id: "cheesyDijon-BalsamicSheetPanMeatloaf",
        name: "Dijon-Balsamic Sheet Pan Meatloaf",
        description:
            "Spreading the meatloaf out in a sheet pan makes for a much faster cooking time, as well as more surface area for the tangy Dijon balsamic sauce and melted cheese. This recipe yields enough for a crowd -- or for excellent meatloaf sandwiches the next day.",
        image: "cheesyDijonBalsamicMeatloaf.jpg",
        videoURL: "/videos/Cheesy_Dijon_Balsamic_Meatloaf.mp4",
        category: "dressings",
        products: ["frenchBalsamic"], //list of specific products this recipe pairs with
        featured: false,
        ingredients: [
            "3/4 cup breadcrumbs",
            "1/4 cup milk",
            "1/4 cup fresh flat-leaf parsley leaves, chopped, plus more for topping",
            "2 large eggs",
            "3/4 cup Food Network Kitchen™ Inspirations French Style Dijon Balsamic Vinaigrette",
            "1/2 cup ketchup",
            "3 pounds meatloaf mix",
            "2 cloves garlic, minced",
            "1 medium onion, grated and excess liquid squeezed out",
            "Kosher salt and freshly ground black pepper",
            "6 ounces Colby Jack cheese, grated",
],
        directions: [
            "Position an oven rack in the upper third of the oven and preheat to 375 degrees F.",
            "Mix together the breadcrumbs, milk, parsley, eggs, 1/4 cup of the French Style Dijon Balsamic Vinaigrette and 1/4 cup of the ketchup in a large bowl. Set aside until the breadcrumbs have absorbed the liquid, about 3 minutes. ," +
            "Add the meatloaf mix, garlic, onion, 1 tablespoon salt and 1/2 teaspoon pepper to the bowl and mix until well combined (take care not to overmix). Transfer the mixture to an 18-by-13-inch sheet pan and press into an even layer covering the entire surface.",
            "Whisk together the remaining 1/2 cup French Style Dijon Balsamic Vinaigrette and 1/4 cup ketchup in a small bowl. Brush the meatloaf with the sauce.",
            "Bake until cooked through, about 20 minutes, then turn the oven to broil. Scatter the cheese over the top and broil, turning the pan periodically for even browning, until the top is caramelized and dark in spots and the cheese is melted, 3 to 4 minutes. Sprinkle with chopped parsley."
        ],
        meta: {
            yield: 8,
            prep: 15,
            total: 40,
            level: "easy"
        }
    },
    {
        id: "kaleCaesarMacCheese",
        name: "Kale Caesar Mac and Cheese",
        description:
            "Rich, creamy and fully loaded with our favorite Caesar salad flavors, this dish uses only one pot from start to finish, making cleanup a breeze.",
        image: "kaleCaesarMacAndCheese.jpg",
        videoURL: "/videos/Kale_Caesar_Mac_N_Cheese.mp4",
        category: "dressings",
        products: ["parmCaesar"], //list of specific products this recipe pairs with
        featured: false,
        ingredients: [
            "4 cups whole milk",
            "12 ounces elbow macaroni (about 3 cups)",
            "8 cups chopped kale",
            "8 ounces mild white Cheddar, shredded (about 2 cups)",
            "3 ounces part-skim mozzarella, shredded (about 3/4 cup)",
            "2 ounces cream cheese, cut into small pieces",
            "Kosher salt and freshly ground black pepper",
            "1 cup Food Network Kitchen™ Inspirations Creamy Parmesan Caesar Dressing",
            "2 tablespoons grated Parmesan",
            "1 cup seasoned croutons",

        ],
        directions: [
            "Add the milk and macaroni to a medium saucepan and bring to a boil over medium heat, stirring frequently to keep the macaroni from clumping. Lower to a simmer and cook, stirring frequently, until the macaroni is tender and the milk has thickened to the consistency of heavy cream, 4 to 5 minutes. Stir in the kale and continue cooking until fully wilted, about 2 minutes.",
            "Lower the heat, add the Cheddar, mozzarella, cream cheese and 1 1/2 teaspoons salt and stir until smooth, thick and creamy. Stir in the Creamy Parmesan Caesar Dressing. Remove from heat and top with the Parmesan, croutons and several grinds of black pepper. (The dish will thicken as it cools; thin it out with a little hot water if desired.)",

        ],
        meta: {
            yield: 4,
            prep: 25,
            total: 25,
            level: "easy"
        }
  },
  //   {
  //       id: "",
  //       name: "",
  //       description:
  //           "",
  //       image: "koreanStyleRiceBowls.jpg",
  //       // videoURL: "/videos/Cheesy_Dijon_Balsamic_Meatloaf.mp4",
  //       category: "",
  //       products: [""], //list of specific products this recipe pairs with
  //       featured: false,
  //       ingredients: [
  //           "4 boneless, skinless chicken breasts",
  //
  //       ],
  //       directions: [
  //           "Preheat the oven to 400 degrees F.",
  //
  //       ],
  //       meta: {
  //           yield: 4,
  //           prep: 10,
  //           total: 40,
  //           level: "easy"
  //       }
  // }
];



// WEBPACK FOOTER //
// ./src/json/recipes.js